var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongRenyuan4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.5a.5.5 0 00-.5-.5h-2A3.5 3.5 0 002 12.5v.5a1.5 1.5 0 001.5 1.5h4a.5.5 0 000-1h-4A.5.5 0 013 13v-.5A2.5 2.5 0 015.5 10h2a.5.5 0 00.5-.5z",
    fill: "#3F465C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5,
    r: 2.5,
    stroke: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62 12.127a2.056 2.056 0 010-.754l-.506-.29a.226.226 0 01-.083-.31l.466-.8a.226.226 0 01.307-.082l.51.291c.192-.163.415-.292.659-.378v-.578c0-.125.1-.226.225-.226h.936c.125 0 .226.101.226.226v.578c.244.086.466.215.66.378l.508-.291a.226.226 0 01.307.082l.467.8a.226.226 0 01-.083.31l-.506.29c.046.25.046.505 0 .754l.506.29a.226.226 0 01.083.31l-.467.8a.226.226 0 01-.307.082l-.509-.291a2.083 2.083 0 01-.659.378v.578a.226.226 0 01-.226.226h-.936a.226.226 0 01-.226-.226v-.578a2.082 2.082 0 01-.659-.378l-.509.291a.226.226 0 01-.307-.082l-.466-.8a.226.226 0 01.083-.31l.506-.29zm2.046.31a.687.687 0 100-1.374.687.687 0 000 1.374z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_renyuan4.25198682.svg";
export { SvgTongyongRenyuan4 as ReactComponent };